// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1XDt8","largestCol":"styles_largestCol__1wZIM","smallestCol":"styles_smallestCol__3ZoRO"};